<div>
  <h1 mat-dialog-title>
    <span>{{ 'NAVBAR.PAGES.EDIT-ACCOUNT.TITLE' | translate }}</span>
  </h1>
  <!-- Desktop structure -->
  <div mat-dialog-content class="d-none d-lg-block h-100 py-2">
    <div class="fix-parent-height-center-center pt-3 pb-5" *ngIf="loadingData">
      <span class="loader"></span>
    </div>
    <mat-tab-group class="vertical-tabs" (selectedTabChange)="tabChanged($event)" *ngIf="!loadingData">
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="mat-tab-label-content">
            <i class="rt-icon rt-usuario-11 fs30"></i>
            {{ 'GLOBAL.ACCOUNT-EDIT-INFO-1' | translate }}
          </div>
        </ng-template>
        <ng-template matTabContent>
          <div class="d-flex flex-column">
            <div class="w-100 h-100 overflow-auto card border-0 dialog-form-container">
              <form [formGroup]="changeUserDataForm">
                <div class="row mx-0 p-2">
                  <div class="col-12 py-2">
                    <span class="h5">
                      {{ 'GLOBAL.ACCOUNT-EDIT-INFO-1' | translate }}
                    </span>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-NAME' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        type="text"
                        autocomplete="off"
                        [readonly]="!nameEdit"
                        [disableControl]="!nameEdit"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-NAME' | translate"
                        formControlName="friendlyName" />
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserDataForm.controls?.friendlyName)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-EMAIL' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        type="text"
                        autocomplete="off"
                        [readonly]="!emailEdit"
                        [disableControl]="!emailEdit"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-EMAIL' | translate"
                        formControlName="email" />
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserDataForm.controls?.email)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="changeUserDataForm.controls?.email.errors && changeUserDataForm.controls?.email.errors.email"
                        >{{ 'GLOBAL.ERRORS.EMAIL-INVALID' | translate }}</mat-hint
                      >
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-LANGUAGE' | translate }}
                      </mat-label>
                      <mat-select [placeholder]="'GLOBAL.ACCOUNT-EDIT-LANGUAGE' | translate" formControlName="language">
                        <mat-option *ngFor="let lang of availableLangs" [value]="lang.language">
                          {{ lang.description }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab *ngIf="editPasswordPermission">
        <ng-template mat-tab-label>
          <div class="mat-tab-label-content">
            <i class="rt-icon rt-seguro fs30 me-2"></i>
            {{ 'GLOBAL.ACCOUNT-EDIT-INFO-2' | translate }}
          </div>
        </ng-template>
        <ng-template matTabContent>
          <div class="d-flex flex-column">
            <div class="w-100 h-100 overflow-auto card border-0 dialog-form-container">
              <form [formGroup]="changeUserPasswordForm" #passwordNgForm="ngForm">
                <div class="row mx-0 p-2">
                  <div class="col-12 py-2">
                    <span class="h5">
                      {{ 'GLOBAL.ACCOUNT-EDIT-INFO-2' | translate }}
                    </span>
                  </div>
                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-CURRENT-PASS' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hidePassCurrent ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-CURRENT-PASS' | translate"
                        formControlName="password" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password" matSuffix [attr.data-selenium]="'toggle-current-password'" (click)="hidePassCurrent = !hidePassCurrent" [ngClass]="{'rt-view': hidePassCurrent, 'rt-hide': !hidePassCurrent}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPasswordForm.controls?.password)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-NEW-PASS' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hidePassNew ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-NEW-PASS' | translate"
                        formControlName="newPassword" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password" matSuffix [attr.data-selenium]="'toggle-new-password'" (click)="hidePassNew = !hidePassNew" [ngClass]="{'rt-view': hidePassNew, 'rt-hide': !hidePassNew}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPasswordForm.controls?.newPassword)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                      <mat-hint class="text-danger animated fadeInDown" *ngIf="changeUserPasswordForm.errors?.fieldsDontMatch">{{
                        'LOGIN.FORM.PASSWORD-DONT-MATCH' | translate
                      }}</mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-REPEAT-NEW-PASS' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hidePassRepeat ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-REPEAT-NEW-PASS' | translate"
                        formControlName="newPasswordConfirm" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password" matSuffix [attr.data-selenium]="'toggle-repeat-new-password'" (click)="hidePassRepeat = !hidePassRepeat" [ngClass]="{'rt-view': hidePassRepeat, 'rt-hide': !hidePassRepeat}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPasswordForm.controls?.newPasswordConfirm)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                      <mat-hint class="text-danger animated fadeInDown" *ngIf="changeUserPasswordForm.errors?.fieldsDontMatch">{{
                        'LOGIN.FORM.PASSWORD-DONT-MATCH' | translate
                      }}</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="mat-tab-label-content">
            <i class="rt-icon rt-clave-1 fs30 me-2"></i>
            {{ 'GLOBAL.ACCOUNT-EDIT-INFO-3' | translate }}
          </div>
        </ng-template>
        <ng-template matTabContent>
          <div class="d-flex flex-column">
            <div class="w-100 h-100 overflow-auto card border-0 dialog-form-container" *ngIf="_userData.isSetPin">
              <form [formGroup]="changeUserPinForm" #pinNgForm="ngForm">
                <div class="row mx-0 p-2">
                  <div class="col-12 py-2">
                    <span class="h5">
                      {{ 'GLOBAL.ACCOUNT-EDIT-INFO-3-PIN' | translate }}
                    </span>
                  </div>
                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-PIN-USER-PASS' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hideCurrentUserPin ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-CURRENT-PIN' | translate"
                        formControlName="currentUserPin" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password-pin" matSuffix [attr.data-selenium]="'toggle-current-password-pin'" (click)="hideCurrentUserPin = !hideCurrentUserPin" [ngClass]="{'rt-view': hideCurrentUserPin, 'rt-hide': !hideCurrentUserPin}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPinForm.controls?.currentUserPin)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-NEW-USER-PIN' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hideUserPinNew ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-NEW-USER-PIN' | translate"
                        formControlName="newPin" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide pin" matSuffix [attr.data-selenium]="'toggle-new-pin'" (click)="hideUserPinNew = !hideUserPinNew" [ngClass]="{'rt-view': hideUserPinNew, 'rt-hide': !hideUserPinNew}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPinForm.controls?.newPin)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                      <mat-hint class="text-danger animated fadeInDown" *ngIf="changeUserPinForm.errors?.fieldsDontMatch">{{
                        'LOGIN.FORM.PIN-DONT-MATCH' | translate
                      }}</mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-REPEAT-NEW-USER-PIN' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hideUserPinRepeat ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-REPEAT-NEW-USER-PIN' | translate"
                        formControlName="newPinConfirm" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide pin" matSuffix [attr.data-selenium]="'toggle-repeat-new-pin'" (click)="hideUserPinRepeat = !hideUserPinRepeat" [ngClass]="{'rt-view': hideUserPinRepeat, 'rt-hide': !hideUserPinRepeat}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPinForm.controls?.newPinConfirm)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                      <mat-hint class="text-danger animated fadeInDown" *ngIf="changeUserPinForm.errors?.fieldsDontMatch">{{
                        'LOGIN.FORM.PIN-DONT-MATCH' | translate
                      }}</mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <small class="d-inline-block w-100 pb-2 text-secondary">
                      {{ 'GLOBAL.FORGOT-USER-PIN' | translate }}
                    </small>
                    <button mat-stroked-button color="primary" class="" (click)="setAndResetUserPin('RecoverPin')">
                      <span>{{ 'GLOBAL.RESET-USER-PIN' | translate }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div class="w-100 h-100 overflow-auto card border-0 dialog-form-container" *ngIf="!_userData.isSetPin">
              <div class="row mx-0 p-2">
                <div class="col-12 py-2">
                  <span class="h5">
                    {{ 'GLOBAL.ACCOUNT-EDIT-INFO-3-PIN' | translate }}
                  </span>
                </div>

                <div class="col-12 pt-2 pb-4">
                  <div class="notify notify-info wb-ball">
                    <span class="notify-message">
                      {{ 'GLOBAL.NO-USER-PIN' | translate }}
                    </span>
                  </div>
                  <div class="d-flex justify-content-center align-items-center py-4">
                    <button mat-stroked-button color="primary" class="" (click)="setAndResetUserPin('SetPin')">
                      <span>{{ 'GLOBAL.SET-USER-PIN' | translate }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
  <!-- Mobile structure -->
  <div mat-dialog-content class="d-lg-none h-100 mh-100 py-2">
    <div class="fix-parent-height-center-center pt-3 pb-5" *ngIf="loadingData">
      <span class="loader"></span>
    </div>
    <mat-accordion class="custom-accordeon parent my-1 w-100" *ngIf="!loadingData">
      <mat-expansion-panel expanded (expandedChange)="expansionChanged($event, 0)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="rt-icon rt-usuario-11 fs30 me-2"></i>
          {{ 'GLOBAL.ACCOUNT-EDIT-INFO-1' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div class="d-flex flex-column">
            <div class="w-100 h-100 overflow-auto card border-0 dialog-form-container">
              <form [formGroup]="changeUserDataForm">
                <div class="row mx-0">
                  <div class="col-12 py-2">
                    <span class="h5">
                      {{ 'GLOBAL.ACCOUNT-EDIT-INFO-1' | translate }}
                    </span>
                  </div>
                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-NAME' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        type="text"
                        autocomplete="off"
                        [readonly]="!nameEdit"
                        [disableControl]="!nameEdit"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-NAME' | translate"
                        formControlName="friendlyName" />
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserDataForm.controls?.friendlyName)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-EMAIL' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        type="text"
                        autocomplete="off"
                        [readonly]="!emailEdit"
                        [disableControl]="!emailEdit"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-EMAIL' | translate"
                        formControlName="email" />
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserDataForm.controls?.email)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="changeUserDataForm.controls?.email.errors && changeUserDataForm.controls?.email.errors.email"
                        >{{ 'GLOBAL.ERRORS.EMAIL-INVALID' | translate }}</mat-hint
                      >
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-LANGUAGE' | translate }}
                      </mat-label>
                      <mat-select [placeholder]="'GLOBAL.ACCOUNT-EDIT-LANGUAGE' | translate" formControlName="language">
                        <mat-option *ngFor="let lang of availableLangs" [value]="lang.language">
                          {{ lang.description }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (expandedChange)="expansionChanged($event, 1)" *ngIf="editPasswordPermission">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="rt-icon rt-seguro fs30 me-2"></i>
          {{ 'GLOBAL.ACCOUNT-EDIT-INFO-2' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div class="d-flex flex-column">
            <div class="w-100 h-100 overflow-auto card border-0 dialog-form-container">
              <form [formGroup]="changeUserPasswordForm" #passwordNgForm="ngForm">
                <div class="row mx-0">
                  <div class="col-12 py-2">
                    <span class="h5">
                      {{ 'GLOBAL.ACCOUNT-EDIT-INFO-2' | translate }}
                    </span>
                  </div>
                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-CURRENT-PASS' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hidePassCurrent ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-CURRENT-PASS' | translate"
                        formControlName="password" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password" matSuffix [attr.data-selenium]="'toggle-current-password'" (click)="hidePassCurrent = !hidePassCurrent" [ngClass]="{'rt-view': hidePassCurrent, 'rt-hide': !hidePassCurrent}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPasswordForm.controls?.password)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-NEW-PASS' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hidePassNew ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-NEW-PASS' | translate"
                        formControlName="newPassword" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password" matSuffix [attr.data-selenium]="'toggle-new-password'" (click)="hidePassNew = !hidePassNew" [ngClass]="{'rt-view': hidePassNew, 'rt-hide': !hidePassNew}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPasswordForm.controls?.newPassword)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                      <mat-hint class="text-danger animated fadeInDown" *ngIf="changeUserPasswordForm.errors?.fieldsDontMatch">{{
                        'LOGIN.FORM.PASSWORD-DONT-MATCH' | translate
                      }}</mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-REPEAT-NEW-PASS' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hidePassRepeat ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-REPEAT-NEW-PASS' | translate"
                        formControlName="newPasswordConfirm" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password" matSuffix [attr.data-selenium]="'toggle-repeat-new-password'" (click)="hidePassRepeat = !hidePassRepeat" [ngClass]="{'rt-view': hidePassRepeat, 'rt-hide': !hidePassRepeat}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPasswordForm.controls?.newPasswordConfirm)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                      <mat-hint class="text-danger animated fadeInDown" *ngIf="changeUserPasswordForm.errors?.fieldsDontMatch">{{
                        'LOGIN.FORM.PASSWORD-DONT-MATCH' | translate
                      }}</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel (expandedChange)="expansionChanged($event, 2)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="rt-icon rt-clave-1 fs30 me-2"></i>
            {{ 'GLOBAL.ACCOUNT-EDIT-INFO-3' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div class="d-flex flex-column">
            <div class="w-100 h-100 overflow-auto card border-0 dialog-form-container" *ngIf="_userData.isSetPin">
              <form [formGroup]="changeUserPinForm" #pinNgForm="ngForm">
                <div class="row mx-0 p-2">
                  <div class="col-12 py-2">
                    <span class="h5">
                      {{ 'GLOBAL.ACCOUNT-EDIT-INFO-3-PIN' | translate }}
                    </span>
                  </div>
                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-PIN-USER-PASS' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hideCurrentUserPin ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-CURRENT-PIN' | translate"
                        formControlName="currentUserPin" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password-pin" matSuffix [attr.data-selenium]="'toggle-current-password-pin'" (click)="hideCurrentUserPin = !hideCurrentUserPin" [ngClass]="{'rt-view': hideCurrentUserPin, 'rt-hide': !hideCurrentUserPin}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPinForm.controls?.currentUserPin)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-NEW-USER-PIN' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hideUserPinNew ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-NEW-USER-PIN' | translate"
                        formControlName="newPin" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide pin" matSuffix [attr.data-selenium]="'toggle-new-pin'" (click)="hideUserPinNew = !hideUserPinNew" [ngClass]="{'rt-view': hideUserPinNew, 'rt-hide': !hideUserPinNew}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPinForm.controls?.newPin)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                      <mat-hint class="text-danger animated fadeInDown" *ngIf="changeUserPinForm.errors?.fieldsDontMatch">{{
                        'LOGIN.FORM.PIN-DONT-MATCH' | translate
                      }}</mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <mat-form-field class="w-100">
                      <mat-label>
                        {{ 'GLOBAL.ACCOUNT-EDIT-REPEAT-NEW-USER-PIN' | translate }}
                      </mat-label>
                      <input
                        matInput
                        required
                        [type]="hideUserPinRepeat ? 'password' : 'text'"
                        autocomplete="new-password"
                        [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-REPEAT-NEW-USER-PIN' | translate"
                        formControlName="newPinConfirm" />
                      <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide pin" matSuffix [attr.data-selenium]="'toggle-repeat-new-pin'" (click)="hideUserPinRepeat = !hideUserPinRepeat" [ngClass]="{'rt-view': hideUserPinRepeat, 'rt-hide': !hideUserPinRepeat}"></i>
                      <mat-hint
                        class="text-danger animated fadeInDown"
                        *ngIf="isFieldRequired(changeUserPinForm.controls?.newPinConfirm)"
                        >{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint
                      >
                      <mat-hint class="text-danger animated fadeInDown" *ngIf="changeUserPinForm.errors?.fieldsDontMatch">{{
                        'LOGIN.FORM.PIN-DONT-MATCH' | translate
                      }}</mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-12 pb-1">
                    <small class="d-inline-block w-100 pb-2 text-secondary">
                      {{ 'GLOBAL.FORGOT-USER-PIN' | translate }}
                    </small>
                    <button mat-stroked-button color="primary" class="" (click)="setAndResetUserPin('RecoverPin')">
                      <span>{{ 'GLOBAL.RESET-USER-PIN' | translate }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div class="w-100 h-100 overflow-auto card border-0 dialog-form-container" *ngIf="!_userData.isSetPin">
              <div class="row mx-0 p-2">
                <div class="col-12 py-2">
                  <span class="h5">
                    {{ 'GLOBAL.ACCOUNT-EDIT-INFO-3-PIN' | translate }}
                  </span>
                </div>

                <div class="col-12 pt-2 pb-4">
                  <div class="notify notify-info wb-ball">
                    <span class="notify-message">
                      {{ 'GLOBAL.NO-USER-PIN' | translate }}
                    </span>
                  </div>
                  <div class="d-flex justify-content-center align-items-center py-4">
                    <button mat-stroked-button color="primary" class="" (click)="setAndResetUserPin('SetPin')">
                      <span>{{ 'GLOBAL.SET-USER-PIN' | translate }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="w-100 text-end p-3" *ngIf="!loadingData">

    <button mat-raised-button data-selenium="button-user-save" *ngIf="currentForm === 0 && nameEdit && emailEdit" type="submit" color="primary" class="ms-2 float-end" [disabled]="changeUserDataForm.pristine || !changeUserDataForm.valid || sendingUserData" (click)="changeUserData()">
      <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingUserData"></i>
      <i class="rt-icon rt-disquete" *ngIf="isMobile && !sendingUserData"></i>
      <span *ngIf="!isMobile && !sendingUserData">{{ 'GLOBAL.SAVE' | translate }}</span>
    </button>

    <button mat-raised-button data-selenium="button-user-save" *ngIf="currentForm === 0 && (!nameEdit && !emailEdit)" type="submit" color="primary" class="ms-2 float-end" [disabled]="changeUserDataForm.pristine || !changeUserDataForm.valid || sendingUserData" (click)="changeLanguage()">
      <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingUserData"></i>
      <i class="rt-icon rt-disquete" *ngIf="isMobile && !sendingUserData"></i>
      <span *ngIf="!isMobile && !sendingUserData">{{ 'GLOBAL.SAVE' | translate }}</span>
    </button>

    <button mat-raised-button data-selenium="button-user-pass-change" *ngIf="currentForm === 1 && editPasswordPermission" type="submit" color="primary" class="ms-2 float-end" [disabled]="!changeUserPasswordForm.valid || sendingPassword || !editPasswordPermission" (click)="changeUserCredentials()">
      <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingPassword"></i>
      <i class="rt-icon rt-disquete" *ngIf="isMobile && !sendingPassword"></i>
      <span *ngIf="!isMobile && !sendingPassword">{{ 'GLOBAL.CHANGE' | translate }}</span>
    </button>

    <button mat-raised-button data-selenium="button-user-pin-change" *ngIf="(currentForm === 1 && _userData.isSetPin && !editPasswordPermission) || (currentForm === 2 && _userData.isSetPin)" type="submit" color="primary" class="ms-2 float-end" [disabled]="!changeUserPinForm.valid || sendingPin" (click)="changeUserPin()">
      <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingPin"></i>
      <i class="rt-icon rt-disquete" *ngIf="isMobile && !sendingPin"></i>
      <span *ngIf="!isMobile && !sendingPin">{{ 'GLOBAL.CHANGE' | translate }}</span>
    </button>

    <button mat-stroked-button data-selenium="button-user-close" color="primary" class="" [disabled]="sendingPassword || sendingUserData" (click)="closeDialog()">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CLOSE' | translate }}</span>
    </button>
  </div>
</div>
